<template>
    <div class="row left-content">
        <div class="col-12">
            <h1>Withdraw</h1>
        </div>
        <div class="col-5">
            <div class="white-block">
                <div class="container">
                    <h3 v-if="wallet">Balance: {{ wallet.wallet.amount + ' ' + wallet.wallet.currency }}</h3>
                    <b-form>
                        <div class="row">
                            <div class="col-12">
                                <b-input-group prepend="$" class="mb-2">
                                    <b-form-input
                                        v-model="form.amount"
                                        type="number"
                                        placeholder="Amount"
                                    ></b-form-input>
                                </b-input-group>
                            </div>
                        </div>
                        <b-button variant="primary" type="submit" @click.prevent.stop="create()">Withdraw</b-button>
                    </b-form>
                    <div class="invalid-feedback d-block" v-for="(error, index) in errors" :key="error">{{ index + ': ' + error }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {ServerErrors} from "@/mixins/ServerErrors";
import Swal from "sweetalert2";
export default {
    name: "Transfer",
    mixins: [ServerErrors],
    data() {
        return {
            errors: [],
            form: {
                amount: 0
            },
            wallet: null
        }
    },
    methods: {
        create() {
            let loader = this.$loading.show();
            this.errors = [];
            window.axios({
                method: 'POST',
                url: '/admin/wallet/project/transfer/create',
                data: {
                    amount: parseFloat(this.form.amount)
                }
            })
                .then(() => {
                    this.$router.push({ name: 'admin.project_wallet.view' });
                })
                .catch(error => {
                    this.errors = this.server_errors;
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: error.response.data.title ? error.response.data.title: "Something went wrong."
                    });
                })
                .finally(() => {
                    loader.hide();
                });
        }
    },
    mounted() {
        let loader = this.$loading.show();
        window.axios.get('/admin/wallet/project/view')
            .then(response => {
                    this.wallet = response.data.wallet;
                }
            )
            .finally(() => {
                loader.hide();
            });
    }
}
</script>